<template>
<div class="event-list">
    <section class="toolbar">
        <b-field>
            <b-input placeholder="Search..." type="search" icon="search" v-model="search">
            </b-input>
        </b-field>
        <b-field>
            <p class="control hover-rotate-90">
                <button class="button is-primary" @click="addEvent()">
                    <b-icon icon="plus" pack="fal"></b-icon>
                </button>
            </p>
        </b-field>
        <b-field>
            <p class="control">
                <button class="button" :class="view === 'grid' ? 'is-primary' : ''" @click="view = 'grid'">
                    <b-icon icon="th-large" pack="far"></b-icon>
                </button>
            </p>
            <p class="control">
                <button class="button " :class="view === 'list' ? 'is-primary' : ''" @click="view = 'list'">
                    <b-icon icon="line-columns" pack="fas"></b-icon>
                </button>
            </p>
        </b-field>

    </section>
    <section class="columns">
        <div class=" menu column is-3 is-narrow-mobile is-fullheight section is-hidden-mobile has-text-left">
            <p class="menu-label">
                Kategorien
            </p>
            <ul class="menu-list">
                <li><a :class="eventCategory == 'all' ? 'is-active' : ''" @click="eventCategory = 'all'"><b-icon size="is-small" icon="calendar-alt"></b-icon>Alle anzeigen</a></li>
                <li><a :class="eventCategory == 'none' ? 'is-active' : ''" @click="eventCategory = 'none'"><b-icon size="is-small" icon="calendar"></b-icon>Nicht kategorisiert</a></li>
                <li v-for="category in $root.settings.categories">
                    <a :class="eventCategory == category.id ? 'is-active' : ''" @click="eventCategory = category.id">
                        <b-icon size="is-small" :icon="category.icon || 'calendar-star'"></b-icon>
                        {{ category.label }}
                        <b-dropdown position="is-bottom-right" v-if="eventCategory == category.id" hoverable append-to-body aria-role="menu" trap-focus>
                            <b-icon slot="trigger" role="button" icon="ellipsis-h" pack="fas" size="is-small" type="is-light"></b-icon>
                            <b-dropdown-item aria-role="listitem" @click="renameCategory(category)">Kategorie umbenennen</b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" @click="deleteCategory(category)">Kategorie löschen</b-dropdown-item>
                        </b-dropdown>
                    </a>
                </li>
                <li><a @click="addCategory()"><b-icon size="is-small" icon="plus" pack="fal"></b-icon>Neue Kategorie</a></li>
            </ul>
            <p class="menu-label">
                Ablage
            </p>
            <ul class="menu-list">
                <li><a :class="eventStatus == 'active' ? 'is-active' : ''" @click="eventStatus = 'active'"><b-icon size="is-small" icon="calendar-check"></b-icon>Aktuell</a></li>
                <li><a :class="eventStatus == 'archive' ? 'is-active' : ''" @click="eventStatus = 'archive'"><b-icon size="is-small" icon="archive"></b-icon>Archiv</a></li>
                <li><a :class="eventStatus == 'trash' ? 'is-active' : ''" @click="eventStatus = 'trash'"><b-icon size="is-small" icon="trash-alt"></b-icon>Papierkorb</a></li>
            </ul>
        </div>
        <div class="container column is-9">
            <div class="section has-text-left" style="display: flex" v-if="view === 'grid'">
                <div class="card is-grid" v-for="event in filtered" >
                    <header class="card-header">
                        <p class="card-header-title">
                            <router-link v-if="eventStatus === 'active'" @click="$root.updateEvent()" :to="'/event/'+event.id">
                                {{event.name}}
                            </router-link>
                            <span v-else>{{event.name}}</span>
                        </p>
                        <b-dropdown position="is-bottom-left" hoverable append-to-body aria-role="menu" trap-focus>
                            <a
                                    class="card-header-icon"
                                    slot="trigger"
                                    role="button">
                                <b-icon icon="ellipsis-h" pack="fas"></b-icon>
                            </a>
                            <b-dropdown-item aria-role="listitem" v-if="eventStatus === 'active' || eventStatus === 'archive'" custom>Kategorie</b-dropdown-item>
                            <b-dropdown-item custom v-if="eventStatus === 'active' || eventStatus === 'archive'" aria-role="listitem">
                                <b-field>
                                    <b-select placeholder="Wählen Sie eine Kategorie" expanded  @input="(value) => {categorizeEvent(event, value)}">
                                        <option value="none">Keine Kategorie</option>
                                        <option  v-for="category in $root.settings.categories" :value="category.id">{{category.label}}</option>
                                    </b-select>
                                </b-field>
                            </b-dropdown-item>

                            <hr class="dropdown-divider" v-if="eventStatus === 'active' || eventStatus === 'archive'">
                            <b-dropdown-item aria-role="listitem" @click="cloneEvent(event)">Duplizieren und aktivieren</b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" v-if="eventStatus === 'trash' || eventStatus === 'archive'" @click="activateEvent(event)">Wiederherstellen</b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" v-if="eventStatus === 'active' || eventStatus === 'trash'" @click="archiveEvent(event)">Archivieren</b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" v-if="eventStatus === 'active' || eventStatus === 'archive'" @click="trashEvent(event)">In den Papierkorb verschieben</b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" v-if="eventStatus === 'trash'" @click="deleteEvent(event)">Endgültig löschen</b-dropdown-item>
                        </b-dropdown>
                    </header>
                    <div class="card-content">
                        <div class="content">
                            <p>
                                <b v-if="event.start == event.end">
                                    {{$moment(event.start, "YYYY-MM-DD").format('DD.MM.YY')}}
                                </b>
                                <b v-else>
                                    {{$moment(event.start, "YYYY-MM-DD").format('DD.MM.YY')}} - {{$moment(event.end, "YYYY-MM-DD").format('DD.MM.YY')}}
                                </b>
                            </p>

                            <b-field grouped group-multiline>
                                <div class="control" v-if="typeof event.counter.recipients !== 'undefined'">
                                    <b-taglist attached>
                                        <b-tag type="is-info">
                                            <b-icon pack="fal" icon="user" size="is-small"></b-icon>
                                        </b-tag>
                                        <b-tag type="is-light">{{event.counter.recipients}}</b-tag>
                                    </b-taglist>
                                </div>

                                <div class="control" v-if="typeof event.stats._attending !== 'undefined'">
                                    <b-taglist attached>
                                        <b-tag type="is-success">
                                            <b-icon pack="fal" icon="check" size="is-small"></b-icon>
                                        </b-tag>
                                        <b-tag type="is-light">{{event.stats._attending.length}}</b-tag>
                                    </b-taglist>
                                </div>

                                <div class="control" v-if="typeof event.stats.count !== 'undefined' && typeof event.counter.recipients !== 'undefined'">
                                    <b-taglist attached>
                                        <b-tag type="is-warning">
                                            <b-icon pack="fal" icon="hourglass-half" size="is-small"></b-icon>
                                        </b-tag>
                                        <b-tag type="is-light">{{(event.counter.recipients-event.stats.count)}}</b-tag>
                                    </b-taglist>
                                </div>

                                <div class="control" v-if="typeof event.stats._notAttending !== 'undefined'">
                                    <b-taglist attached>
                                        <b-tag type="is-danger">
                                            <b-icon pack="fal" icon="ban" size="is-small"></b-icon>
                                        </b-tag>
                                        <b-tag type="is-light">{{(event.stats._notAttending.length)}}</b-tag>
                                    </b-taglist>
                                </div>
                            </b-field>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section has-text-left" v-if="view === 'list'">
                <b-table :data="filtered" narrowed mobile-cards>
                    <template slot-scope="props">
                        <b-table-column field="id" label="ID" width="40" numeric>
                            {{ props.row.id }}
                        </b-table-column>
                        <b-table-column field="name" label="Name">
                            <router-link v-if="eventStatus === 'active'" @click="$root.updateEvent()" :to="'/event/'+props.row.id">
                                {{props.row.name}}
                            </router-link>
                            <span v-else>{{props.row.name}}</span>
                        </b-table-column>
                        <b-table-column field="time" label="Zeitraum">
                            <b v-if="props.row.start == props.row.end">
                                {{$moment(props.row.start, "YYYY-MM-DD").format('DD.MM.YY')}}
                            </b>
                            <b v-else>
                                {{$moment(props.row.start, "YYYY-MM-DD").format('DD.MM.YY')}} - {{$moment(props.row.end, "YYYY-MM-DD").format('DD.MM.YY')}}
                            </b>
                        </b-table-column>
                        <b-table-column field="stats" label="Statistik">
                                <b-taglist attached>
                                    <b-tag type="is-info" v-if="typeof props.row.counter.recipients !== 'undefined'">{{props.row.counter.recipients}}</b-tag>
                                    <b-tag type="is-success" v-if="typeof props.row.stats._attending !== 'undefined'">{{props.row.stats._attending.length}}</b-tag>
                                    <b-tag type="is-warning" v-if="typeof props.row.stats.count !== 'undefined' && typeof props.row.counter.recipients !== 'undefined'">{{(props.row.counter.recipients-props.row.stats.count)}}</b-tag>
                                    <b-tag type="is-danger" v-if="typeof props.row.stats._notAttending !== 'undefined'">{{(props.row.stats._notAttending.length)}}</b-tag>
                                </b-taglist>
                        </b-table-column>
                        <b-table-column field="actions" width="50">
                            <b-dropdown position="is-bottom-left" hoverable append-to-body aria-role="menu" trap-focus>
                                <a
                                        class="button is-small"
                                        slot="trigger"
                                        role="button">
                                    <b-icon icon="ellipsis-h" pack="fas"></b-icon>
                                </a>
                                <b-dropdown-item aria-role="listitem" v-if="eventStatus === 'active' || eventStatus === 'archive'" custom>Kategorie</b-dropdown-item>
                                <b-dropdown-item custom v-if="eventStatus === 'active' || eventStatus === 'archive'" aria-role="listitem">
                                    <b-field>
                                        <b-select placeholder="Wählen Sie eine Kategorie" expanded  @input="(value) => {categorizeEvent(props.row, value)}">
                                            <option value="none">Keine Kategorie</option>
                                            <option  v-for="category in $root.settings.categories" :value="category.id">{{category.label}}</option>
                                        </b-select>
                                    </b-field>
                                </b-dropdown-item>

                                <hr class="dropdown-divider" v-if="eventStatus === 'active' || eventStatus === 'archive'">
                                <b-dropdown-item aria-role="listitem" @click="cloneEvent(props.row)">Duplizieren und aktivieren</b-dropdown-item>
                                <b-dropdown-item aria-role="listitem" v-if="eventStatus === 'trash' || eventStatus === 'archive'" @click="activateEvent(props.row)">Wiederherstellen</b-dropdown-item>
                                <b-dropdown-item aria-role="listitem" v-if="eventStatus === 'active' || eventStatus === 'trash'" @click="archiveEvent(props.row)">Archivieren</b-dropdown-item>
                                <b-dropdown-item aria-role="listitem" v-if="eventStatus === 'active' || eventStatus === 'archive'" @click="trashEvent(props.row)">In den Papierkorb verschieben</b-dropdown-item>
                                <b-dropdown-item aria-role="listitem" v-if="eventStatus === 'trash'" @click="deleteEvent(props.row)">Endgültig löschen</b-dropdown-item>
                            </b-dropdown>
                        </b-table-column>
                    </template>
                </b-table>
            </div>
        </div>
    </section>
</div>
</template>

<script>
export default {
    name: 'EventList',
    props: {
        msg: String
    },
    data() {
        return {
            search: '',
            rerenderCategories: 0,
            eventStatus: 'active',
            eventCategory: 'all',
            view: 'grid'
        }
    },
    methods: {
        addEvent(){
            this.$root.createEvent()
            return
        },
        activateEvent(event){
            this.$root.activateEvent(event.id)
            return
        },
        categorizeEvent(event, category = 'none'){
            this.$root.categorizeEvent(event.id, category)
            return
        },
        trashEvent(event){
            this.$root.trashEvent(event.id)
            return
        },
        archiveEvent(event){
            this.$root.archiveEvent(event.id)
            return
        },
        deleteEvent(event){
            this.$root.deleteEvent(event.id)
            return
        },
        cloneEvent(event){
            this.$root.cloneEvent(event.id)
            this.eventStatus = 'active'
            return
        },
        addCategory(){
            this.$buefy.dialog.prompt({
                message: `Name der Kategorie`,
                inputAttrs: {
                    placeholder: 'Mitarbeiterevents',
                    maxlength: 30
                },
                trapFocus: true,
                onConfirm: (value) => {
                    if(!Array.isArray(this.$root.settings.categories)) this.$root.settings.categories = []
                    this.$root.settings.categories.push({
                        label: value,
                        id: this.$root.uuid()
                    })
                    this.$root.saveSettings()
                    this.rerenderCategories++
                }
            })
        },
        renameCategory(category){
            this.$buefy.dialog.prompt({
                message: `Name der Kategorie`,
                inputAttrs: {
                    value: category.label,
                    maxlength: 30
                },
                trapFocus: true,
                onConfirm: (value) => {
                    category.label = value
                    this.$root.saveSettings()
                    this.rerenderCategories++
                }
            })
        },
        deleteCategory(category){

            if(this.$root.events.filter(e => e.category === category.id).length > 0){
                this.$buefy.dialog.alert({
                    title: 'Kategorie nicht leer',
                    message: 'Der Kategorie sind noch Events zugeordnet. Bitte leeren Sie die Kategorie um sie zu löschen.',
                    type: 'is-warning',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                })
                return
            }
            this.$root.settings.categories = this.$root.settings.categories.filter(c => c.id !== category.id)
            this.$root.saveSettings()
            this.rerenderCategories++
        }
    },
    computed: {
        filtered() {
            var origin = this.$root.events,
                filtered = [],
                patt = new RegExp(this.search, "i");

            if(this.eventCategory === 'none') origin = origin.filter(e => (e.category == 'none' || e.category === null))
            if(this.eventCategory !== 'none' && this.eventCategory !== 'all') origin = origin.filter(e => e.category == this.eventCategory)

            if(this.eventStatus === 'trash') origin = origin.filter(e => (e.status == 'removed' || e.status == 'trash'))
            if(this.eventStatus === 'active') origin = origin.filter(e => e.status == 'active')
            if(this.eventStatus === 'archive') origin = origin.filter(e => e.status == 'archive')

            if (this.search == '') {
                return origin
            }
            if (this.search.length < 3) {
                return origin
            }
            filtered = []
            origin.forEach(entry => {
                if (patt.test(entry.name)) {
                    filtered.push(entry)
                    return
                }
            })
            return filtered
        }
    },
    filters: {
        nl2br: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.replace(/(\r\n|\n|\r)/gm, "<br>")
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.menu span.icon{
    margin-right: 10px;
}
    section.toolbar .field{
        display: inline-flex;
        padding-left: 10px;
    }
    section.toolbar{
        text-align: right;
    }
    .buttons .dropdown{
        margin-right: 0.5rem;
    }
    .menu-list .dropdown .dropdown-trigger a {
        padding: 0;
    }
    .menu-list .dropdown {
        float: right;
    }
    .menu-list .dropdown:after {
        clear: both;
    }
</style>
